import { render } from "./CampaignDetails.vue?vue&type=template&id=7d850873&scoped=true"
import script from "./CampaignDetails.vue?vue&type=script&lang=js"
export * from "./CampaignDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7d850873"

export default script